import type { ReactNode } from 'react';
import { Icon, type IconName } from './Icon.js';

/**
 * Empty state as a small composition (DESIGN_UPGRADE §3.5) — a line-icon mark with a faint teal
 * glow, a serif one-liner, a dimmed sub-line and an optional CTA, all floating over one radial glow
 * blob so the empty canvas reads *authored*, never a bare "no data". Reused across every surface.
 */
export function EmptyState({
  icon,
  title,
  sub,
  cta,
}: {
  icon: IconName;
  title: string;
  sub?: string;
  cta?: ReactNode;
}): JSX.Element {
  return (
    <div className="empty-state">
      <span className="glow-blob es-blob" />
      <span className="es-icon"><Icon name={icon} /></span>
      <div className="es-title">{title}</div>
      {sub && <div className="es-sub">{sub}</div>}
      {cta && <div className="es-cta">{cta}</div>}
    </div>
  );
}
